import { BpmnModel, BpmnModelHelper, BpmnModelJsonHelper, ExtensionElement, SequenceFlow } from "@edp-pmf/bpmn-model";
import { BillCreationType } from "./BillCreationType";
import { BillRelationType } from "./BillRelationType";
import { Component, Tool } from "@edp-bpm/bpmn-common-model";
import { ComponentType } from "./ComponentType";

export class SequenceActivity extends SequenceFlow {
  static Clr_Type_ID: string = "bpm.AifSequenceActivity";
  ClrTypeID = SequenceActivity.Clr_Type_ID;
  static MEXTAG = "bpm.AifSequenceActivity";

  isBillNodeToBillNode: boolean;
  srcDataId: string;
  billRelationType: BillRelationType = BillRelationType.CREATION;
  billCreationType: BillCreationType = BillCreationType.AUTO;
  aifAutoProcessCode: string;
  aifPushProcessCode: string;
  aifPullProcessCode: string;
  componentType = ComponentType.CommonComponent;
  componentId: string;
  componentName: string;
  componentSuCode: string;
  expressionText: string;

  tools: Array<Tool> = [];

  constructor(model: BpmnModel) {
    super(model);
  }

  ResetBeforeLoadFrom() {
    super.ResetBeforeLoadFrom();

    this.isBillNodeToBillNode = false;
    this.srcDataId = null;
    this.billRelationType = BillRelationType.CREATION;
    this.billCreationType = BillCreationType.AUTO;
    this.aifAutoProcessCode = null;
    this.aifPushProcessCode = null;
    this.aifPullProcessCode = null;
    this.componentType = ComponentType.CommonComponent;
    this.componentId = null;
    this.componentName = null;
    this.componentSuCode = null;
    this.tools = [];
    this.expressionText = null;
  }

  ConvertToJsonObject(): any {
    let obj = super.ConvertToJsonObject();

    BpmnModelHelper.SetAttributeValue(obj, "isBillNodeToBillNode", this.isBillNodeToBillNode);
    BpmnModelHelper.SetAttributeValue(obj, "srcDataId", this.srcDataId);
    BpmnModelHelper.SetAttributeValue(obj, "billRelationType", this.billRelationType);
    BpmnModelHelper.SetAttributeValue(obj, "billCreationType", this.billCreationType);
    BpmnModelHelper.SetAttributeValue(obj, "aifAutoProcessCode", this.aifAutoProcessCode);
    BpmnModelHelper.SetAttributeValue(obj, "aifPushProcessCode", this.aifPushProcessCode);
    BpmnModelHelper.SetAttributeValue(obj, "aifPullProcessCode", this.aifPullProcessCode);
    BpmnModelHelper.SetAttributeValue(obj, "componentType", this.componentType);
    BpmnModelHelper.SetAttributeValue(obj, "componentId", this.componentId);
    BpmnModelHelper.SetAttributeValue(obj, "componentName", this.componentName);
    BpmnModelHelper.SetAttributeValue(obj, "componentSuCode", this.componentSuCode);
    BpmnModelHelper.SetAttributeValue(obj, "expressionText", this.expressionText);

    return obj;
  }

  LoadFromJsonObject(obj: any) {
    super.LoadFromJsonObject(obj);

    this.isBillNodeToBillNode = BpmnModelJsonHelper.GetAttributeValueAsBoolean(obj, "isBillNodeToBillNode");
    this.srcDataId = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "srcDataId");
    this.billRelationType = BillRelationType[BpmnModelJsonHelper.GetAttributeValueAsString(obj, "billRelationType")];
    this.billCreationType = BillCreationType[BpmnModelJsonHelper.GetAttributeValueAsString(obj, "billCreationType")];
    this.aifAutoProcessCode = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "aifAutoProcessCode");
    this.aifPushProcessCode = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "aifPushProcessCode");
    this.aifPullProcessCode = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "aifPullProcessCode");
    this.componentType = ComponentType[BpmnModelJsonHelper.GetAttributeValueAsString(obj, "componentType")];
    this.componentId = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "componentId");
    this.componentName = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "componentName");
    this.componentSuCode = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "componentSuCode");
    this.expressionText = BpmnModelJsonHelper.GetAttributeValueAsString(obj, "expressionText");
  }

  protected GetExtensionElements4ConvertTo(): ExtensionElement[] {
    const list = super.GetExtensionElements4ConvertTo();

    if (this.tools != null && this.tools.length > 0) {
      this.tools.forEach(it => {
        it.MexTag = SequenceActivity.MEXTAG;
        list.push(it);
      });
    }

    return list;
  }

  protected SetExtensionElements4LoadFrom(extensionElements: ExtensionElement[]): void {
    super.SetExtensionElements4LoadFrom(extensionElements);

    extensionElements.forEach(it => {
      if (it instanceof Tool && it.MexTag == SequenceActivity.MEXTAG) {
        this.tools.push(it);
      }
    });
  }

  NewInstance() {
    return new SequenceActivity(this.Model);
  }

  clone(): SequenceActivity {
    const clone = super.clone() as SequenceActivity;

    clone.isBillNodeToBillNode = this.isBillNodeToBillNode;
    clone.srcDataId = this.srcDataId;
    clone.billRelationType = this.billRelationType;
    clone.billCreationType = this.billCreationType;
    clone.aifAutoProcessCode = this.aifAutoProcessCode;
    clone.aifPushProcessCode = this.aifPushProcessCode;
    clone.aifPullProcessCode = this.aifPullProcessCode;
    clone.componentType = this.componentType;
    clone.componentId = this.componentId;
    clone.componentName = this.componentName;
    clone.componentSuCode = this.componentSuCode;
    clone.expressionText = this.expressionText;

    clone.tools = [];
    if (this.tools && this.tools.length > 0) {
      for (const tool of this.tools) {
        if (tool instanceof Component) {
          const t = tool.clone();
          clone.tools.push(t);
        }
      }
    }

    return clone;
  }
}
BpmnModelHelper.RegisterElementType(new SequenceActivity(new BpmnModel()));
